export default "__VITE_ASSET__Bhj2a3PY__"